export default {
  // Appointment Status
  'appointment-status.booked': 'The appointment was booked and confirmed',
  'appointment-status.canceled': 'The appointment was cancelled',
  'appointment-status.missed': 'You missed the appointment',
  'appointment-status.finished': 'The appointment was attended',
  'appointment-status.ongoing': 'The appointment is in progress',
  'appointment-status.pending': 'Appointment confirmation pending',
  'appointment-status.reserved': 'This appointment is reserved for you',
  'appointment-status.requested': 'The appointment was requested',
  'appointment-status.not-yet-pending': 'The appointment is not available yet',

  // Appointment status short
  'appointment-status.booked.short': 'Booked',
  'appointment-status.canceled.short': 'Cancelled',
  'appointment-status.missed.short': 'Missed',
  'appointment-status.finished.short': 'Attended',
  'appointment-status.ongoing.short': 'In progress',
  'appointment-status.pending.short': 'Pending',
  'appointment-status.reserved.short': 'Reserved',
  'appointment-status.requested.short': 'Requested',
  'appointment-status.not-yet-pending.short': 'Unavailable',

  // Relationships
  'relationship.child': 'Child',
  'relationship.friend': 'Friend',
  'relationship.other': 'Other',
  'relationship.parent': 'Parent',
  'relationship.sibling': 'Sibling',
  'relationship.spouse': 'Spouse',

  // Relationship status
  'relationship.status.active': 'Active',
  'relationship.status.paused': 'Paused',
  'relationship.status.pending-ward-approval': 'In ward approval',
  'relationship.status.pending-legal-guardian-approval': 'In guardian approval',

  // Relationship status description
  'relationship.status.active.description': 'Guardianship is active.',
  'relationship.status.paused.description':
    'While the guardianship is paused, no actions can be performed by the guardian.',
  'relationship.status.pending-ward-approval.description': 'Confirmation from the ward pending.',
  'relationship.status.pending-legal-guardian-approval.description':
    'Confirmation from legal guardian pending.',

  // Appointment request status short
  'appointment-request.approved.short': 'Approved',
  'appointment-request.archived.short': 'Archived',
  'appointment-request.cancelled.short': 'Cancelled',
  'appointment-request.created.short': 'Created',
  'appointment-request.fulfilled.short': 'Booked',
  'appointment-request.in-proposal.short': 'Appointment proposals pending',
  'appointment-request.submitted.short': 'Sent',
  'appointment-request.rejected.short': 'Rejected',
  'appointment-request.proposal-rejected.short': 'Proposals rejected',

  // Appointment Reuqest status
  'appointment-request.approved': 'The request was confirmed by the facility',
  'appointment-request.archived': 'The appointment request was archived by the facility',
  'appointment-request.cancelled': 'The appointment request was canceled',
  'appointment-request.created': 'Created',
  'appointment-request.fulfilled': 'Appointment was booked',
  'appointment-request.in-proposal': 'Confirmation of the proposed dates pending',
  'appointment-request.submitted': 'Request was forwarded to the facility',
  'appointment-request.rejected': 'Request was rejected by the facility',
  'appointment-request.proposal-rejected':
    'Appointment proposals were rejected on the patient side',

  // Appointment request status description
  'appointment-request.approved.description':
    'Your appointment request has been confirmed by the selected facility and a list of available appointments will be emailed to you shortly.',
  'appointment-request.archived.description':
    'The selected facility has archived your appointment.',
  'appointment-request.cancelled.description': 'You have cancelled the appointment request.',
  'appointment-request.created.description':
    'Appointment request has been created but not yet sent.',
  'appointment-request.fulfilled.description':
    'An appointment has been successfully booked for your request. You can view it below.',
  'appointment-request.in-proposal.description':
    'Please let the selected facility know which date works best for you. You can select them below.',
  'appointment-request.submitted.description':
    'The facility you selected has received the appointment request and will process it shortly.',
  'appointment-request.rejected.description':
    'The selected facility has rejected your appointment request with the reasons "{reason}".',
  'appointment-request.proposal-rejected.description':
    'You have indicated that you cannot accept any of the appointments proposed by the selected facility.',

  // Week days
  'weekday.monday': 'Monday',
  'weekday.tuesday': 'Tuesday',
  'weekday.wednesday': 'Wednesday',
  'weekday.thursday': 'Thursday',
  'weekday.friday': 'Friday',
  'weekday.saturday': 'Saturday',
  'weekday.sunday': 'Sunday',

  // Sex
  'sex.male': 'Male',
  'sex.female': 'Female',
  'sex.diverse': 'Diverse',

  'sex.m': 'M',
  'sex.w': 'F',
  'sex.x': 'X',

  'month.january': 'January',
  'month.february': 'February',
  'month.march': 'March',
  'month.april': 'April',
  'month.may': 'May',
  'month.june': 'June',
  'month.july': 'July',
  'month.august': 'August',
  'month.september': 'September',
  'month.october': 'October',
  'month.november': 'November',
  'month.december': 'December',

  'appointment-request.location.in-person': 'In person',
  'appointment-request.location.video': 'Video',
  'appointment-request.location.phone': 'Phone',
  'appointment-request.location.none': '',

  'appointment-request.rejected.no-reason':
    'The appointment request was rejected by the facility without stating any reasons.',
};
